<template>


    <div class="hidden sm:block mt-3 overflow-x-auto">
        <table class="w-full table-auto font-mono text-sm mt-4 text-left px-2 overflow-x-auto">
            <thead class="font-mono">
            <tr class="">
                <th class="px-2 py-3">{{ $t('orders.pos') }}.</th>
                <th class="px-2 py-3">{{ $t('orders.article') }}</th>
                <th class="px-2 py-3">{{ $t('orders.description') }}</th>
                <th class="px-2 py-3 text-center">B</th>
                <th class="px-2 py-3 text-center">G</th>
                <th class="px-2 py-3 text-center">S</th>
                <th class="px-2 py-3 text-center">R</th>
                <th class="px-2 py-3 text-center">{{ $t('orders.payment') }}</th>
                <th class="px-2 py-3 text-center">{{ $t('orders.shipment') }}</th>
                <th class="px-2 py-3 text-right">CHF Netto</th>
                <th class="px-2 py-3 text-right">CHF MWST</th>
                <th class="px-2 py-3 text-right">{{ $t('orders.code') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="lineItem of form.lineItems" :key="lineItem.id"
                class="event:bg-gray-100 odd:bg-gray-300">
                <td class="px-2 py-3">{{ lineItem.position }}</td>
                <td class="px-2 py-3">{{ lineItem.sku }}</td>
                <td class="px-2 py-3 uppercase">{{ lineItem.description }}</td>
                <td class="px-2 py-3 text-center">{{ lineItem.orderQty }}</td>
                <td class="px-2 py-3 text-center">{{ lineItem.shipQty }}</td>
                <td class="px-2 py-3 text-center">{{ lineItem.cancelQty }}</td>
                <td class="px-2 py-3 text-center">{{ lineItem.returnQty }}</td>
                <td class="px-2 py-3 text-center">
                    <status
                        v-if="!editing"
                        :status="lineItem.payment"></status>
                    <Dropdown v-model="lineItem.payment.state"
                              v-if="editing"
                              :options="paymentStates"
                              class="w-full"
                              optionValue="state"
                              appendTo="body"
                              optionLabel="name"
                              :placeholder="$t('orders.paymentState')">
                    </Dropdown>
                </td>
                <td class="px-2 py-3 text-center">
                    <status
                        v-if="!editing"
                        :status="lineItem.fulfillment"></status>
                    <Dropdown v-model="lineItem.fulfillment.state"
                              v-if="editing"
                              :options="fulfillmentStates"
                              class="w-full"
                              optionValue="state"
                              appendTo="body"
                              optionLabel="name"
                              :placeholder="$t('orders.paymentState')">
                    </Dropdown>
                </td>
                <td class="px-2 py-3 text-right">{{ lineItem.netPriceFormatted }}</td>
                <td class="px-2 py-3 text-right">{{ lineItem.taxFormatted }}</td>
                <td class="px-2 py-3 text-right">{{ lineItem.taxCode }}</td>
            </tr>
            </tbody>
        </table>
    </div>


    <div class="mt-5 overflow-hidden sm:rounded-md font-mono sm:hidden">
        <ul role="list" class="">
            <li v-for="lineItem in form.lineItems" :key="lineItem.id" class="mt-4 bg-white">
                <div class="px-4 py-4 sm:px-6">
                    <div class="flex items-center justify-between">
                        <p class="font-medium text-black truncate">
                            {{ lineItem.position }} - {{ lineItem.sku }} - {{ lineItem.description }}
                        </p>
                    </div>
                    <div class="mt-2 sm:flex sm:justify-between">
                        <div class="sm:flex space-y-2">
                            <div class="flex flex-row space-x-4 space-y-2">
                                <p class="mt-2 flex items-center text-sm text-gray-500">
                                    B: {{ lineItem.orderQty }}
                                </p>
                                <p class="flex items-center text-gray-500">
                                    G: {{ lineItem.shipQty }}
                                </p>
                                <p class="flex items-center text-gray-500">
                                    S: {{ lineItem.cancelQty }}
                                </p>
                                <p class="flex items-center text-gray-500">
                                    R: {{ lineItem.returnQty }}
                                </p>
                            </div>

                            <p class="flex items-center text-gray-500">
                                {{ lineItem.netPriceFormatted }}
                            </p>

                            <p class="flex text-sm text-gray-500 items-center">
                                <BanknotesIcon class="h-5 w-5 mr-2"></BanknotesIcon>
                                <status
                                    v-if="!editing"
                                    :status="lineItem.payment"></status>
                                <Dropdown v-model="lineItem.payment"
                                          v-if="editing"
                                          :options="paymentStates"
                                          class="w-full"
                                          optionValue="state"
                                          appendTo="body"
                                          optionLabel="name"
                                          :placeholder="$t('orders.paymentState')">
                                </Dropdown>
                            </p>

                            <p class="flex text-sm text-gray-500 items-center">
                                <TruckIcon class="h-5 w-5 mr-2"></TruckIcon>
                                <status
                                    v-if="!editing"
                                    class="flex"
                                    :status="lineItem.fulfillment"></status>
                                <Dropdown v-model="lineItem.fulfillment"
                                          v-if="editing"
                                          :options="fulfillmentStates"
                                          class="w-full"
                                          optionValue="state"
                                          appendTo="body"
                                          optionLabel="name"
                                          :placeholder="$t('orders.paymentState')">
                                </Dropdown>

                            </p>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import OrderTracking from "@/Pages/Sales/Order/Components/OrderTracking";
import OrderContact from "@/Pages/Sales/Order/Components/OrderContact";
import OrderTaxTable from "@/Pages/Sales/Order/Components/OrderTaxTable";
import OrderAddress from "@/Pages/Sales/Order/Components/OrderAddress";
import OrderHead from "@/Pages/Sales/Order/Components/OrderHead";
import OrderState from "@/Pages/Sales/Order/Components/OrderState";
import Detail from "@/Pages/Sales/Order/Detail";
import AppLayout from "@/Layouts/AppLayout";
import Status from "@/Shared/Components/Status";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetButton from "@/Jetstream/PrimaryButton";
import Dropdown from "primevue/dropdown";
import Checkbox from "@/Jetstream/Checkbox";
import JetLabel from "@/Jetstream/Label";
import {BanknotesIcon, TruckIcon} from "@heroicons/vue/24/outline";

export default {
    name: "Overview",
    props: ['order', 'paymentStates', 'fulfillmentStates', 'lineItems', 'editing', 'form'],
    layout: [AppLayout, Detail],
    components: {
        Status,
        OrderTracking,
        OrderContact,
        OrderTaxTable,
        OrderAddress,
        OrderHead,
        OrderState,
        JetSecondaryButton,
        JetButton,
        Dropdown,
        Checkbox,
        JetLabel,
        TruckIcon,
        BanknotesIcon
    },
}
</script>

<style scoped>

</style>
